import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';

export function Navbar() {
  const { user, logout } = useAuth();
  const { itemCount } = useCart();
  const location = useLocation();

  const navLinks = [
    { to: '/', label: 'Products' },
    { to: '/demos', label: 'Demos' },
    { to: '/cart', label: 'Cart', testId: 'navbar-cart-link' },
  ];

  return (
    <nav className="sticky top-0 z-50 border-b border-white/[0.06] bg-navy-950/70 backdrop-blur-2xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src="/images/edg3_labs_logo_light.svg"
            alt="Edg3 Labs"
            className="h-9 w-auto transition-all duration-300 group-hover:scale-105"
          />
        </Link>

        <div className="hidden items-center gap-8 sm:flex">
          {navLinks.map(({ to, label, testId }) => {
            const isActive = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                data-testid={testId}
                aria-current={isActive ? 'page' : undefined}
                className={`font-display text-sm font-medium transition-colors duration-200 relative pb-1 ${isActive ? 'text-white' : 'text-gray-400 hover:text-white'}`}
              >
                {label}
                {isActive && <span className="absolute inset-x-0 -bottom-0.5 h-0.5 rounded-full bg-green-500" />}
              </Link>
            );
          })}
        </div>

        <div className="flex items-center gap-4">
          <button aria-label="Search" className="hidden sm:flex text-gray-400 hover:text-white transition-colors p-2 rounded-lg hover:bg-white/5">
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>
          </button>
          <Link to="/cart" className="relative text-gray-400 hover:text-white transition-colors duration-200 sm:hidden">
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
            </svg>
            {itemCount > 0 && (
              <span data-testid="cart-badge" className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-green-500 text-[10px] font-bold text-white ring-2 ring-navy-950">
                {itemCount}
              </span>
            )}
          </Link>

          {user ? (
            <div className="flex items-center gap-3">
              <Link to="/account" className="font-display text-sm font-medium text-gray-400 hover:text-white transition-colors">
                Account
              </Link>
              <button
                onClick={() => logout()}
                className="font-display text-sm text-gray-500 hover:text-white transition-colors"
              >
                Logout
              </button>
              {user.avatarUrl && (
                <img src={user.avatarUrl} alt="" className="h-7 w-7 rounded-full ring-2 ring-white/10" />
              )}
            </div>
          ) : (
            <Link
              to="/account"
              className="font-display rounded-lg bg-gradient-to-r from-teal-600 to-green-600 px-4 py-1.5 text-sm font-medium text-white shadow-lg shadow-teal-500/20 hover:shadow-teal-500/30 transition-all duration-300 hover:brightness-110"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
